module.exports = __webpack_public_path__ + "img/forms-active.fdb7bace.svg";